import React, { Fragment, useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import moment from "moment";

import { BeneficiariesInitialLoad, BeneficiariesPagination } from "../../../store/thunk/BeneficiariesThunk";
import { BeneficiariesIsLoading, BeneficiariesWithPagination } from "../../../store/selectors/BeneficiariesSelector";
import PageLoader from "../../layouts/PageLoader";
import { sumDonationAmount } from "../../../helper/formater";

const Beneficiaries = ({ beneficiaries, isLoading }) => {

   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
   const dispatch = useDispatch();
   useEffect(() => {
      if (BeneficiariesInitialLoad)
         dispatch(BeneficiariesInitialLoad());
   }, [])

   useEffect(() => {

      const timer = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
         dispatch(BeneficiariesPagination({ q: searchQuery, pageNumber: 1 }))
      }, 500); // Adjust the delay as needed

      return () => clearTimeout(timer); // Cleanup on each render
   }, [searchQuery])

   const clearFilter = () => {
      setSearchQuery('');
   }

   return (
      <Fragment>
         <PageLoader isLoading={isLoading} >
            {/* <PageTitle activeMenu="Donors List" motherMenu="Donors" /> */}
            <div className="row">
               <div className="col-lg-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="row">
                           <div className="col-lg-4">
                              <div className="input-group search-area">
                                 <input type="text"
                                    className={`form-control active`}
                                    placeholder="Search"
                                    onChange={(e) => setSearchQuery(e.currentTarget.value)}
                                    value={searchQuery}
                                 />
                                 <span className="input-group-text" >
                                    <i className="flaticon-381-search-2"></i>
                                 </span>
                              </div>
                           </div>
                           <div className="col-lg-2">
                              <div className="input-group">
                                 { searchQuery && (
                                    <Button onClick={clearFilter}>Clear Filter</Button>
                                 )}
                              </div>
                           </div>
                           <div className="col-lg-6 text-end">
                              <Link className={`btn btn-outline-secondary`} to={`/new-beneficiary`}>Add Beneficiary</Link>
                              {/* <Button variant="secondary" onClick={}>Add Beneficiary</Button> */}
                           </div>
                        </div>
                        <br />
                        <div className="table-responsive">
                           <table className="table mb-0 table-striped">
                              <thead>
                                 <tr>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Total Residents</th>
                                    <th>Incharge</th>
                                    <th>Contact No.</th>
                                    <th>Address</th>
                                    <th>Preferences</th>
                                    <th>Created On</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <tbody id="Beneficiaries">
                                 {
                                    beneficiaries?.data?.map((beneficiary, index) => {
                                       return (
                                          <tr className="btn-reveal-trigger" key={index}>
                                             <td className="py-3">
                                                <div className="media d-flex align-items-center">
                                                   <div className="media-body">
                                                      <h5 className="mb-0 fs--1">
                                                         {beneficiary?.name}
                                                      </h5>
                                                   </div>
                                                </div>
                                             </td>
                                             <td className="py-2" dangerouslySetInnerHTML={{__html:beneficiary?.type.join('<br>')}}></td>
                                             <td className="py-2">
                                                {beneficiary?.total_residents}
                                             </td>
                                             <td className="py-2">
                                                {beneficiary?.incharge}
                                             </td>
                                             <td className="py-2 ">
                                                {beneficiary?.contact_no}
                                             </td>
                                             <td>{beneficiary?.location}<br />{beneficiary?.address}</td>
                                             <td className="py-2">{beneficiary?.special_preferences}</td>
                                             <td className="py-2">{moment(beneficiary?.created_at).format("DD MMM YYYY")}</td>
                                             <td className="py-2 text-right">
                                                <Link className="btn btn-xs btn-outline-primary" to={`/update-beneficiary/${beneficiary?.id}`}>
                                                   Edit
                                                </Link>
                                                {/* <Dropdown>
                                                   <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
                                                      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                         <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24"></rect>
                                                            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                         </g>
                                                      </svg>
                                                   </Dropdown.Toggle>
                                                   <Dropdown.Menu>
                                                      <Link to={`/update-beneficiary/${beneficiary?.id}`}>
                                                         <Dropdown.Item href={`/update-beneficiary/${beneficiary?.id}`} >Edit</Dropdown.Item>
                                                      </Link>
                                                      <Link to={`/view-beneficiary/${beneficiary?.id}`}>
                                                         <Dropdown.Item href={`/donor-details/${beneficiary?.id}`} >View</Dropdown.Item>
                                                      </Link>
                                                      {/* <Dropdown.Item href="#" className="text-danger">
                                                      Delete
                                                   </Dropdown.Item> *}
                                                   </Dropdown.Menu>
                                                </Dropdown> */}
                                             </td>
                                          </tr>
                                       )
                                    })
                                 }



                              </tbody>
                           </table>
                        </div>
                        <br />
                        <div>
                           <Pagination
                              activePage={beneficiaries?.current_page ? beneficiaries?.current_page : 0}
                              itemsCountPerPage={beneficiaries?.per_page ? beneficiaries?.per_page : 0}
                              totalItemsCount={beneficiaries?.total ? beneficiaries?.total : 0}
                              onChange={(pageNumber) => {
                                 dispatch(BeneficiariesPagination({ q: searchQuery, pageNumber }))
                              }}
                              pageRangeDisplayed={8}
                              itemClass="page-item"
                              linkClass="page-link"
                              firstPageText="First Page"
                              lastPageText="Last Page"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </PageLoader>

      </Fragment>
   );
};


const mapStateToProps = (state) => {
   return {
      beneficiaries: BeneficiariesWithPagination(state),
      isLoading: BeneficiariesIsLoading(state)
   };
};

export default connect(mapStateToProps)(Beneficiaries);